import Typography from '@mui/material/Typography';
import { ReferenceField } from 'react-admin';

import { AccountAvatar } from '../accounts/AccountAvatar';
import type { ActivityQuoteNoteCreated } from '../types';
import { SaleName } from '../sales/SaleName';
import { RelativeDate } from '../misc/RelativeDate';
import { ActivityLogNote } from './ActivityLogNote';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogQuoteNoteCreatedProps = {
    activity: ActivityQuoteNoteCreated;
};

export function ActivityLogQuoteNoteCreated({
    activity,
}: ActivityLogQuoteNoteCreatedProps) {
    const context = useActivityLogContext();
    const { quoteNote } = activity;
    return (
        <ActivityLogNote
            header={
                <>
                    <ReferenceField
                        source="quote_id"
                        reference="quotes"
                        record={quoteNote}
                        link={false}
                    >
                        <ReferenceField
                            source="account_id"
                            reference="accounts"
                            link={false}
                        >
                            <AccountAvatar width={20} height={20} />
                        </ReferenceField>
                    </ReferenceField>
                    <Typography
                        component="p"
                        variant="body2"
                        color="text.secondary"
                        flexGrow={1}
                    >
                        <ReferenceField
                            source="sales_id"
                            reference="sales"
                            record={activity}
                            link={false}
                        >
                            <SaleName />
                        </ReferenceField>{' '}
                        added a note about quote{' '}
                        <ReferenceField
                            source="quote_id"
                            reference="quotes"
                            record={quoteNote}
                            link="show"
                        />
                        {context !== 'account' && (
                            <>
                                {' at '}
                                <ReferenceField
                                    source="quote_id"
                                    reference="quotes"
                                    record={quoteNote}
                                    link={false}
                                >
                                    <ReferenceField
                                        source="account_id"
                                        reference="accounts"
                                        link="show"
                                    />
                                </ReferenceField>{' '}
                                <RelativeDate date={activity.date} />
                            </>
                        )}
                    </Typography>
                    {context === 'account' && (
                        <Typography
                            color="textSecondary"
                            variant="body2"
                            component="span"
                        >
                            <RelativeDate date={activity.date} />
                        </Typography>
                    )}
                </>
            }
            text={quoteNote.text}
        />
    );
}
